import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API = `${process.env.VUE_APP_API_URL}users/report`;

export default {
  list(params) {
    return axios.get(`${API}/list`, { params, headers: buildHeaders() });
  },
  report(params) {
    return axios.get(API, { params, headers: buildHeaders() });
  },
  exportReport(format, params) {
    return axios.get(`${API}/export`, {
      params: { ...params, format },
      responseType: "blob",
      headers: buildHeaders()
    });
  }
};
